import React from 'react'
import PropTypes from 'prop-types'
// TODO: Drop `react-visibility-sensor` for `intersection-observer`
import ReactVisibilitySensor from 'react-visibility-sensor'

import { sendTrackingEvent } from '$utils/tracking'

const CLICK_EVENT = 'Brand Click'
const IMPRESSION_EVENT = 'Brand Impression'
const CLICKABLE_IMPRESSION_EVENT = 'Brand Impression Clickable'

// TODO: to refactor because global variable is a bad practice...
// If the context was a true webapp, it should be set in global state of application
window.BRANDS_ON_PAGE = []

// HACK: The dependency `react-visibility-sensor` had an issue during packaging
// (double bundling ? wrong webpack config ?) that wraped the actual modul in a
// esm interop twice. Instead of having the module exposing its component as a
// default import (so when bundled, exposing an object with the component on the
// `default` property), the module exposes a module that exposes the component
// (so an object like `{ default: { default: Component } }`) This causes errors
// with react since we try to use `{default:Component}` as a component. Those
// errors are difficult to track because the error stack will only run through
// react code (since it is the `React.createElement` that will emit and
// intercept the error).
//
// to fix the issue we import default, and use the `default` property on that to
// get the actual component
const VisibilitySensor = ReactVisibilitySensor.default

const handleUserIdList = userId => {
  const pattern = `_${userId}_`
  if (!window.BRANDS_ON_PAGE.includes(pattern)) {
    window.BRANDS_ON_PAGE.push(pattern)
  }
}

class SponsorshipTracker extends React.Component {
  state = {
    sendedEvents: []
  }

  track = (eventType, eventPosition, userId, data = {}) => {
    sendTrackingEvent('Brand visibility', eventType, {
      event: 'BRANDevent',
      eventLabel: `_${userId}_`,
      logoId: eventPosition,
      ...data
    })

    this.setState({ sendedEvents: [...this.state.sendedEvents, eventType] })
  }

  trackImpression = (isVisible, visibilityRect) => {
    if (isVisible) {
      let eventType

      if (!this.props.clickEventConfig.enable) {
        eventType = IMPRESSION_EVENT
      } else {
        eventType = CLICKABLE_IMPRESSION_EVENT
      }

      if (this.props.impressionEventConfig.sendOnce && !this.state.sendedEvents.includes(eventType)) {
        this.track(eventType, this.props.position, this.props.userId, { nonInteractionEvent: true })
      }
    }
  }

  trackClick = event => {
    if (this.props.clickEventConfig.sendOnce && !this.state.sendedEvents.includes(CLICK_EVENT)) {
      const linkUrl = event && event.target.href
      this.track(CLICK_EVENT, this.props.position, this.props.userId, { linkUrl })
    }
  }

  componentDidMount() {
    handleUserIdList(this.props.userId)
  }

  render() {
    const { children, clickEventConfig, impressionEventConfig, position, userId, ...props } = this.props

    let enhancedChildren

    if (clickEventConfig.enable) {
      let newOnClickProp
      if (children.props.onClick) {
        newOnClickProp = event => {
          this.trackClick(event)
          children.props.onClick(event)
        }
      } else {
        newOnClickProp = this.trackClick
      }

      enhancedChildren = React.cloneElement(children, {
        onClick: newOnClickProp,
        onContextMenu: this.trackClick
      })
    } else {
      enhancedChildren = children
    }

    if (impressionEventConfig.enable) {
      return (
        <VisibilitySensor onChange={this.trackImpression} {...props}>
          {enhancedChildren}
        </VisibilitySensor>
      )
    } else {
      return enhancedChildren
    }
  }
}

SponsorshipTracker.defaultProps = {
  clickEventConfig: {
    enable: true,
    sendOnce: true
  },
  impressionEventConfig: {
    enable: true,
    sendOnce: true
  }
}

SponsorshipTracker.propTypes = {
  clickEventConfig: PropTypes.shape({
    enable: PropTypes.bool,
    sendOnce: PropTypes.bool
  }),
  impressionEventConfig: PropTypes.shape({
    enable: PropTypes.bool,
    sendOnce: PropTypes.bool
  }),
  position: PropTypes.string.isRequired,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

export default SponsorshipTracker
